(() => {
  const estimate = ({area, width, gap, spacing, extra}) => {
    if (![area, width, gap, spacing, extra].every(Number.isFinite) || area <= 0 || width <= 0 || spacing <= 0 || gap < 0 || extra < 0) return null;
    const raw = area * 144 / spacing / (width + gap) * 2;
    const total = Math.ceil(raw * (1 + extra / 100) - 1e-9);
    return Number.isSafeInteger(total) && total > 0 ? {raw, total} : null;
  };
  const packCount = (total, capacity) => capacity > 0 ? Math.ceil(total / capacity) : null;
  if (typeof module !== 'undefined' && module.exports) module.exports = {estimate, packCount};
  if (typeof document === 'undefined') return;
  const init = () => document.querySelectorAll('[data-coastal-calculator]').forEach(calc => {
    if (calc.dataset.ready) return;
    calc.dataset.ready = 'true';
    const root = calc.closest('[data-coastal-product]');
    const size = calc.querySelector('[data-calc-size]');
    const pack = calc.querySelector('[data-calc-pack]');
    const fields = [...calc.querySelectorAll('[data-calc-field]')];
    const error = calc.querySelector('[data-calc-error]');
    const result = calc.querySelector('[data-calc-result]');
    const confirm = calc.querySelector('[data-calc-confirm]');
    const apply = calc.querySelector('[data-calc-apply]');
    const format = new Intl.NumberFormat(document.documentElement.lang || 'en');
    let packChosen = false;
    let latest = null;
    const render = () => {
      confirm.textContent = '';
      latest = fields.every(input => input.checkValidity()) ? estimate(Object.fromEntries(fields.map(input => [input.dataset.calcField, Number(input.value)]))) : null;
      error.hidden = Boolean(latest);
      error.textContent = latest ? '' : calc.dataset.invalid;
      result.hidden = !latest;
      apply.disabled = !latest;
      if (!latest) return;
      if (!packChosen) {
        const capacity = latest.total <= 100 ? 100 : latest.total <= 500 ? 500 : 1000;
        const option = [...pack.options].find(option => Number(option.value.match(/\b(1000|500|100)\s*pcs\b/i)?.[1]) === capacity);
        if (option) pack.value = option.value;
      }
      const capacity = Number(pack.value.match(/\b(1000|500|100)\s*pcs\b/i)?.[1] || 0);
      latest.count = packCount(latest.total, capacity);
      if (!latest.count) {
        error.hidden = false; error.textContent = calc.dataset.noVariant; apply.disabled = true; result.hidden = true; return;
      }
      calc.querySelector('[data-calc-total]').textContent = format.format(latest.total);
      calc.querySelector('[data-calc-count]').textContent = format.format(latest.count);
      calc.querySelector('[data-calc-covered]').textContent = format.format(latest.count * capacity);
    };
    fields.forEach(input => input.addEventListener('input', render));
    pack.addEventListener('change', () => {packChosen = true; render();});
    size.addEventListener('change', () => {confirm.textContent = '';});
    calc.addEventListener('toggle', () => {
      if (!calc.open) return;
      const current = root.querySelector('[data-vtx-option-group][data-option-index="0"] [data-vtx-option-current]');
      if (current) size.value = current.textContent.trim();
      render();
    });
    apply.addEventListener('click', () => {
      render();
      if (!latest) {fields.find(input => !input.checkValidity())?.reportValidity(); return;}
      let variants = [];
      try {variants = JSON.parse(root.querySelector('[data-vtx-product-variants]').textContent);} catch {return;}
      const variant = variants.find(variant => variant.options[0] === size.value && variant.options[1] === pack.value);
      if (!variant) {error.hidden = false; error.textContent = calc.dataset.noVariant; return;}
      const select = root.querySelector('[data-vtx-variant-select]');
      select.value = String(variant.id);
      select.dispatchEvent(new Event('change', {bubbles: true}));
      const quantity = root.querySelector('input[name="quantity"]');
      quantity.value = String(latest.count);
      quantity.dispatchEvent(new Event('change', {bubbles: true}));
      confirm.textContent = calc.dataset.applied;
      root.querySelector('[data-vtx-option-group] [data-vtx-option-value].is-active')?.focus({preventScroll: true});
    });
    const productForm = root.querySelector('product-form form');
    productForm?.addEventListener('submit', event => {
      if (productForm.checkValidity()) return;
      event.preventDefault(); event.stopImmediatePropagation(); productForm.reportValidity();
    }, true);
    render();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
